<template>
  <section id="schedule" class="page-section schedule-section">
    <div class="schedule-content">
      <div class="schedule-form">
        <div class="schedule-panel">
          <CampaignScheduler
            :show-scheduler="true"
            :validation="scheduleValidation"
            :initial-schedule="campaignSchedule"
            @schedule-change="emitScheduleChange"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import CampaignScheduler, { type CampaignSchedule } from '@/components/CampaignScheduler.vue'

const { scheduleValidation, campaignSchedule } = defineProps<{
  scheduleValidation: Record<string, unknown>
  campaignSchedule: CampaignSchedule | null
  scheduledStart?: string | null
  scheduledEnd?: string | null
  timeUntilLaunch?: string | null
  timezone?: string | null
}>()

const emit = defineEmits<{
  (e: 'schedule-change', payload: CampaignSchedule): void
}>()

const emitScheduleChange = (payload: CampaignSchedule) => {
  emit('schedule-change', payload)
}
</script>

<style scoped>
.schedule-section {
  justify-content: center;
  align-items: stretch;
  /* Must clear the fixed page header on mobile — using the canonical
     section top padding keeps spacing in line with the other steps. */
  padding-top: var(--section-padding-block-start);
  padding-bottom: var(--footer-clearance);
}

.schedule-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--base-layout-spacing-2xl);
  width: 100%;
  max-width: var(--base-layout-section-max-width);
  margin: 0 auto;
  padding: 0;
}

.schedule-form {
  background-color: var(--color-background-soft);
  border-radius: var(--base-layout-panel-border-radius);
  padding: 0;
  width: 100%;
  max-width: var(--base-layout-schedule-form-max-width);
  margin: 0 auto;
}

.schedule-panel {
  background-color: var(--color-background-tertiary);
  border-radius: var(--base-layout-card-border-radius);
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--base-layout-section-subheading-margin-bottom);
  width: 100%;
  max-width: var(--base-layout-schedule-form-max-width);
  margin: 0 auto;
}

.schedule-panel h4 {
  font-size: var(--base-layout-section-heading-h4-size);
  font-weight: var(--base-layout-section-heading-h4-weight);
  color: var(--color-heading);
  margin-bottom: var(--base-layout-section-heading-h4-margin-bottom);
}

.panel-description {
  color: var(--color-text);
  margin-bottom: 0;
  font-size: var(--base-layout-section-description-size);
}

@media (max-width: 768px) {
  .schedule-section {
    padding-top: calc(var(--section-padding-block-start) + 1rem);
    padding-bottom: calc(var(--control-nav-size) + 2rem + env(safe-area-inset-bottom, 0px));
  }

  .schedule-content {
    gap: var(--base-layout-spacing-lg);
  }
}
</style>
